import { render, staticRenderFns } from "./RacunovodstvoNalozi.vue?vue&type=template&id=38bcdbac"
import script from "./RacunovodstvoNalozi.vue?vue&type=script&lang=js"
export * from "./RacunovodstvoNalozi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports